import { formatDistanceToNow, format, parseISO } from 'date-fns';

export const formatDate = (dateString, style = 'full') => {
  if (!dateString) return '';
  const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
  switch (style) {
    case 'full': return format(date, 'MMMM d, yyyy');
    case 'short': return format(date, 'MMM d, yyyy');
    case 'relative': return formatDistanceToNow(date, { addSuffix: true });
    case 'time': return format(date, 'h:mm a');
    case 'datetime': return format(date, 'MMM d, yyyy · h:mm a');
    default: return format(date, 'MMMM d, yyyy');
  }
};

export const formatNumber = (num) => {
  if (!num) return '0';
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toString();
};

export const getCategoryColor = (category) => {
  const colors = {
    Technology: '#3b82f6',
    World: '#10b981',
    Finance: '#f59e0b',
    Science: '#8b5cf6',
    Entertainment: '#ec4899',
    Politics: '#dc143c',
    Health: '#06b6d4',
    Sports: '#f97316'
  };
  return colors[category] || '#6b7280';
};

export const truncateText = (text, length = 150) => {
  if (!text || text.length <= length) return text;
  return text.substring(0, length).replace(/\s+\S*$/, '') + '…';
};

export const stripHtml = (html) => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

export const getReadingTime = (content) => {
  if (!content) return 1;
  const words = stripHtml(content).trim().split(/\s+/).length;
  return Math.max(1, Math.ceil(words / 200));
};

export const shareArticle = async (title, url) => {
  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return true;
    } catch { return false; }
  }
  try {
    await navigator.clipboard.writeText(url);
    return 'copied';
  } catch { return false; }
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

export const generateInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};
